<template>
  <BaseLoading  opaque :spinning="collegeTeamHighlightLoading">
    <CollegeForm :resource="collegeTeamHighlight" working-type="edit" />
  </BaseLoading>
</template>

<script>
import { CollegeTeamHighlight } from "@/models";
import { mapGetters } from "vuex";
import CollegeForm from "./form";

const COLLEGE_TEAM_HIGHLIGHT_STORE = "collegeTeamHighlightStore";

export default {
  components: {
    CollegeForm
  },
  created() {
    this.dispatcher();
  },
  data() {
    return {
      resource: new CollegeTeamHighlight()
    };
  },
  computed: {
    ...mapGetters({
      collegeTeamHighlight: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlight`,
      collegeTeamHighlightLoading: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlightLoading`
    })
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(
        `${COLLEGE_TEAM_HIGHLIGHT_STORE}/getCollegeTeamHighlight`,
        {
          id: this.$route.params["id"]
        }
      );
    }
  }
};
</script>

<style lang="sass" scoped></style>
